import { render, staticRenderFns } from "./StatusDialogsTabLinks.vue?vue&type=template&id=68513340"
import script from "./StatusDialogsTabLinks.vue?vue&type=script&lang=js"
export * from "./StatusDialogsTabLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports